/**
 * Handles Razorpay payment initialization and checkout flow
 */

/**
 * Initialize and open Razorpay checkout
 * @param {Object} options - Razorpay options
 * @param {string} options.key - Razorpay key ID
 * @param {string} options.amount - Amount in paise
 * @param {string} options.currency - Currency code (INR)
 * @param {string} options.order_id - Razorpay order ID
 * @param {string} options.name - Merchant name (hub name)
 * @param {string} options.image - Logo image URL (hub logo)
 * @param {string} options.description - Order description
 * @param {Object} options.prefill - Prefill customer details
 * @param {Object} options.theme - Theme customization
 * @param {Function} options.modal - Modal options
 * @returns {Promise} - Resolves with payment response or rejects with error
 */
export const openRazorpayCheckout = (options) => {
  return new Promise((resolve, reject) => {
    // Check if Razorpay is loaded
    if (typeof window.Razorpay === 'undefined') {
      reject(new Error('Razorpay SDK not loaded. Please check script tag in index.html'));
      return;
    }

    const razorpayOptions = {
      key: options.key,
      amount: options.amount,
      currency: options.currency || 'INR',
      name: options.name || 'SmartKart',
      image: options.image || '',
      description: options.description || 'Order Payment',
      order_id: options.order_id,
      handler: function (response) {
        // Payment successful
        resolve({
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
        });
      },
      prefill: {
        name: options.prefill?.name || '',
        email: options.prefill?.email || '',
        contact: options.prefill?.contact !== undefined ? options.prefill.contact : '',
      },
      theme: {
        color: options.theme?.color || '#1976d2',
      },
      modal: {
        ondismiss: function () {
          // User closed the modal without payment
          reject(new Error('Payment cancelled by user'));
        },
        ...options.modal, // Allow additional modal options
      },
    };

    const razorpay = new window.Razorpay(razorpayOptions);
    razorpay.open();
  });
};
